import Marquee from "react-fast-marquee";
import { mediaUrl } from "../lib/api";

export const Brands = ({ brands = [] }) => {
  if (!brands.length) return null;
  return (
    <section id="marcas" data-testid="brands-section" className="border-y border-black/5 bg-glg-light py-16 sm:py-20">
      <div className="mx-auto mb-10 max-w-7xl px-5 sm:px-8">
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-glg-blue">Marcas y tecnologías</p>
        <h2 className="mt-3 max-w-2xl font-heading text-2xl font-semibold tracking-tight text-glg-black sm:text-3xl">
          Trabajamos con equipos y tecnologías reconocidas del mercado
        </h2>
      </div>

      <Marquee gradient gradientColor="#F8F9FA" gradientWidth={80} speed={40} pauseOnHover>
        {brands.concat(brands).map((b, i) => (
          <div key={`${b.name}-${i}`} data-testid={`brand-${(b.name || "").toLowerCase()}`} className="mx-6 flex items-center">
            {b.logo ? (
              <img src={mediaUrl(b.logo)} alt={b.name} className="h-10 w-auto object-contain opacity-70 transition-opacity hover:opacity-100 sm:h-12" />
            ) : (
              <span className="font-heading text-3xl font-bold tracking-tight text-black/30 transition-colors duration-300 hover:text-glg-black sm:text-4xl">
                {b.name}
              </span>
            )}
            <span className="mx-8 h-1.5 w-1.5 rounded-full bg-glg-orange/60" />
          </div>
        ))}
      </Marquee>
    </section>
  );
};
